/* global CarouselSlider */

if (!customElements.get('product-card-image-slider')) {
  customElements.whenDefined('carousel-slider').then(() => {
    class ProductCardImageSlider extends CarouselSlider {
      constructor() {
        super();
        this.productCard = this.closest('product-card') || this.closest('.card');
        this.productCardSwatches = this.productCard.querySelectorAll(
          '[data-collection-color-option-group="true"] input.js-card-swatch-input[data-media-id]'
        );
        this.slides = this.querySelectorAll('.slider__item');
        this.activeSwatchMediaId = null;

        if (this.hasAttribute('data-deferred-images')) {
          const hydrateImages = () => {
            this.querySelectorAll('template[data-deferred-card-image]').forEach((template) => {
              template.replaceWith(template.content.cloneNode(true));
            });
            this.removeAttribute('data-deferred-images');
          };
          ['pointerenter', 'focusin', 'touchstart', 'click'].forEach((eventName) => {
            this.addEventListener(eventName, hydrateImages, { once: true, passive: true, capture: true });
          });
          this.querySelector('.slider')?.addEventListener('scroll', hydrateImages, { once: true, passive: true });
        }

        this.productCard.addEventListener('change', this.handleSwatchChange.bind(this));
      }

      init() {
        super.init();
        if (!this.slider) return;

        this.slider.addEventListener('scroll', this.scrollInProgress.bind(this));

        if (this.productCardSwatches.length) {
          const activeSlide = this.querySelector('.slider__item[aria-current]');
          const activeSwatchId = this.pendingSwatchMediaId
            || this.productCard.querySelector(
              '[data-collection-color-option-group="true"] input.js-card-swatch-input[data-media-id]:checked'
            )?.dataset.mediaId
            || activeSlide?.dataset.mediaId;
          let activeSwatchSlide;

          if (activeSwatchId) {
            this.productCardSwatches.forEach((swatch) => {
              const swatchSlide = this.querySelector(`[data-media-id="${swatch.dataset.mediaId}"]`);
              if (swatchSlide) {
                swatchSlide.setAttribute('data-swatch-anchor', 'true');
                if (swatchSlide.dataset.mediaId === activeSwatchId) {
                  activeSlide?.removeAttribute('aria-current');
                  swatchSlide.setAttribute('aria-current', 'true');
                  activeSwatchSlide = swatchSlide;
                }
              }
            });
          }

          if (activeSwatchSlide) this.handleSwatchChange(null, activeSwatchSlide.dataset.mediaId);
          this.pendingSwatchMediaId = null;
        } else {
          const activeSlide = this.querySelector('.slider__item[aria-current]') || this.slides[0];
          if (activeSlide) {
            activeSlide.setAttribute('aria-current', 'true');
            this.handleSwatchChange(null, activeSlide.dataset.mediaId);
          }
        }

        this.updateSlideVisibility();
      }

      updateSlideVisibility() {
        this.slides.forEach((slide) => {
          slide.hidden = false;
        });
        this.setButtonStates();
      }

      handleSwatchChange(evt, mediaId) {
        const swatchMediaId = evt?.target.dataset.mediaId || mediaId;
        if (!swatchMediaId) return;
        const swatchMediaKey = String(swatchMediaId);

        if (!this.slider) {
          this.pendingSwatchMediaId = swatchMediaId;
          return;
        }

        this.updateSlideVisibility();

        const variantMedia = this.querySelector(`[data-media-id="${swatchMediaId}"]`);
        if (!variantMedia) return;

        const variantSlide = variantMedia.closest('.slider__item');
        if (!variantSlide) return;

        const left = variantSlide.offsetLeft;
        const alreadyAtTarget = Math.abs(this.slider.scrollLeft - left) <= 1;

        if (this.activeSwatchMediaId === swatchMediaKey && alreadyAtTarget) return;

        this.activeSwatchMediaId = swatchMediaKey;
        this.slider.querySelector('[aria-current]')?.removeAttribute('aria-current');
        variantSlide.setAttribute('aria-current', 'true');

        if (!alreadyAtTarget) {
          this.slider.scrollTo({ left, behavior: 'instant' });
        }
      }

      setButtonStates() {
        if (!this.prevBtn && !this.nextBtn) return;

        const currentSlideIndex = Math.round(this.slider.scrollLeft / this.slideSpan) + 1;
        const visibleSlideCount = Array.from(this.slides)
          .filter((slide) => slide.hidden !== true).length;

        this.prevBtn.disabled = currentSlideIndex === 1
          || (this.getSlideVisibility(this.slides[0]) && this.slider.scrollLeft === 0);
        this.nextBtn.disabled = visibleSlideCount === currentSlideIndex
          || this.getSlideVisibility(this.slides[this.slides.length - 1]);
      }

      scrollInProgress() {
        this.slider.querySelector('[aria-current]')?.removeAttribute('aria-current');
      }

      handleScroll() {
        super.handleScroll();
        const currentSlide = this.slides[this.currentIndex];
        if (!currentSlide) return;
        currentSlide.setAttribute('aria-current', 'true');
      }
    }

    customElements.define('product-card-image-slider', ProductCardImageSlider);
  });
}

